// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalCreateQualiphyProcedure_root__3GGTP","footer":"ModalCreateQualiphyProcedure_footer__14H3S","additionData":"ModalCreateQualiphyProcedure_additionData__2oHyH"};